import { render } from "./LookUpValues.vue?vue&type=template&id=0af082a8&ts=true"
import script from "./LookUpValues.vue?vue&type=script&lang=ts"
export * from "./LookUpValues.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__